import dayjs, { Dayjs } from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { FC } from 'react';
import { Chip } from '../../../../components/chip/chip';
import { useLang } from '../../../../hooks/use-lang';
import s from './table-date-presets.module.css';

// Ensure Monday is the first day of the week
dayjs.extend(isoWeek);

const getDateRange = (type: 'day' | 'week' | 'month', offset = 0): Dayjs[] => {
  const baseDate = dayjs().subtract(offset, 'day');

  switch (type) {
    case 'day':
      return [baseDate.startOf('day'), baseDate.endOf('day')];
    case 'week':
      return [baseDate.startOf('isoWeek'), dayjs().endOf('day')];
    case 'month':
      return [dayjs().startOf('month'), dayjs().endOf('day')];
    default:
      return [];
  }
};

export type PresetType = {
  key: string;
  label: string;
  range: Dayjs[];
};

const presets: PresetType[] = [
  { key: 'today', label: 'Сегодня', range: getDateRange('day') },
  { key: 'yesterday', label: 'Вчера', range: getDateRange('day', 1) },
  { key: 'week', label: 'Неделя', range: getDateRange('week', 7) },
  { key: 'month', label: 'Месяц', range: getDateRange('month') },
];

interface Props {
  onClick: (preset: PresetType) => void;
  activePresetKey?: string;
}

export const TableDatePresets: FC<Props> = ({ onClick, activePresetKey }) => {
  const { t } = useLang();

  return (
    <ul className={s.feature}>
      {presets.map(({ key, label, range }) => (
        <Chip
          key={key}
          className={s.chip}
          active={activePresetKey === key}
          onClick={() => onClick({ key, label, range })}
        >
          {t(label)}
        </Chip>
      ))}
    </ul>
  );
};
